<template>
  <v-container
    id="home"
    class="pb-0 px-0"
    fluid
    tag="section"
  >
    <headline />

    <gallery-home />
  </v-container>
</template>

<script>
  export default {
    name: 'Home',

    components: {
      GalleryHome: () => import('@/components/GalleryHome'),
      Headline: () => import('./components/Headline'),
    },
  }
</script>
